<div class="topic-count-wrapper" *ngIf="list?.length">
  <div class="d-flex gap-5">
    <ng-content select=”.prefix></ng-content>
    <div class="d-flex gap-2" *ngFor="let item of list;">
      <div class="count">{{ item?.count }}</div>
      <div class="d-flex flex-column justify-content-center">
        <small class="category">{{ item?.category }}</small>
        <ng-container [ngSwitch]="item?.labelType">
          <h4 *ngSwitchCase="'label'">{{ item?.label }}</h4>
          <span
            *ngSwitchCase="'status'"
            class="status"
            [ngStyle]="{background: item?.status?.backgroundColorCode, color: item?.status?.colorCode}"
          >{{ item?.status?.title }}</span>
        </ng-container>
      </div>
    </div>
    <ng-content select=”.suffix”></ng-content>
  </div>
</div>